<template>
    <div class="justifyContentBOX">
         <HotelDailyCost  @hotelDailyCost ="hotelDailyCostValue"/>
         <b-field />
          <b-checkbox type="is-primary" v-model="obj.isSetExceptionCities" >
            <b-field  label="Do you want to set exception cities that will have a different price threshold?"></b-field>
          </b-checkbox>
          <div v-if="obj.isSetExceptionCities"  class="edittravelpolicy2" >

          <b-field class="HotelAverageBox"  label="Hotel average nightly cost for exceptions cities is more than $">
            <b-input  type="number" v-model="obj.exceptionCitiesDailyCost" @input="$emit('hotelDailyCostForExceptionCities',obj)"/>
            </b-field>
            <b-field >
            <CityCodeSelector
            placeholder="e.g. Boston"
            icon="magnify"
            :choices="getCityCodes"
            :selected="obj.exceptionCities"
            @list="getSelectedExceptionCities"
            ></CityCodeSelector>
         </b-field></div>
    </div>
</template>
<script>
import HotelDailyCost from './HotelDailyCost.vue';
import CityCodeSelector from '../../Tags/CityCodeSelector.vue';
import { eventBus } from '../../../main';

export default{
    name: "HotelDailyCostWithExceptionCities",
    props : { 
        hotelExceptionCities : null
     },
    components: {HotelDailyCost,CityCodeSelector},
    data(){
        return {
            obj : {
                isSetExceptionCities: false,
                exceptionCities : [],
                exceptionCitiesDailyCost : null,
                dailyCost :null
            }
        }
    },
    computed:{
        getCityCodes(){
            //return Object.entries(this.$globals.cityCodes);
            //console.log(this.$store.state.options.cities);
            return Object.entries(this.$store.state.options.cities).map(([key, value]) => ({ key, value }));
        }
    },
    methods:{

        hotelDailyCostValue(val) {
         this.obj.dailyCost=val;
         this.$emit('hotelDailyCostForExceptionCities',this.obj);
        },
        getSelectedExceptionCities(){
            // console.log(this.obj);
            // console.log(this.obj.exceptionCities.map(city => city.key));
            this.$emit('hotelDailyCostForExceptionCities',this.obj);
        }
    },
    mounted() {
    this.$emit('hotelDailyCostForExceptionCities',this.obj);
    this.obj = this.hotelExceptionCities
    console.log(this.obj)
    eventBus.$emit('hotelDailyCost',this.obj.dailyCost)
    }
}
</script>